'use strict';

import axios from 'axios';

const apiService = () => next => async action => {

	const result = next(action);

	if (!action.meta || !action.meta.async) {
		return result;
	}

	const { endPoint, method = 'GET', body, params, headers } = action.meta;

	const config = {
		method,
		url: endPoint
	};

	if (params) {
		config.params = params
	}

	if (body) {
		config.data = body;
	}

	if (headers) {
		config.headers = headers;
	}

	return new Promise((resolve, reject) => axios(config).then(
		res => {
			const { data } = res;

			if (data.success) {
				next({
					type: `${ action.type }_COMPLETED`,
					data: data.data,
					meta: action.meta
				});
				resolve(data);

			} else {

				const _data = { message: data.message, code: data.code };

				next({
					type: `${ action.type }_FAILED`,
					data: _data,
					meta: action.meta
				});
				reject(data);
			}
		},
		err => {

			const _data = { message: err.response.statusText };

			next({
				type: `${ action.type }_FAILED`,
				data: _data,
				meta: action.meta
			});
			reject(data);
		}
	));
};

export default apiService;
